import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Applying a professional theme with black and gold colors
const themeStyles = {
  backgroundColor: '#000000', // Black background
  color: '#FFD700', // Gold text
  fontFamily: 'Arial, sans-serif',
  height: '100vh',
  margin: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

root.render(
  <React.StrictMode>
    <div style={themeStyles}>
      <App />
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
